import * as React from 'react';
import { useState, useEffect } from 'react';

import { Text, Html, ContactShadows, PresentationControls, Float, Environment, useGLTF } from '@react-three/drei';
import { useSpring, animated } from '@react-spring/three';
// import { OrbitControls } from '@react-three/drei';


export default function Experience() {
    const computer = useGLTF('https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/macbook/model.gltf');
    const [isTurnedOn, setIsTurnedOn] = useState(false);

    // Define the spring animation for the computer model
    const { scale } = useSpring({
        from: { scale: [0, 0, 0] },
        to: { scale: [1, 1, 1] },
        config: { mass: 5, tension: 400, friction: 50 },
        delay: 500, // Delay in ms before the animation starts
    });

    const [mouse, setMouse] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleTouchStart = (event) => {
        setMouse({
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY,
        });
        };

        const handleTouchMove = (event) => {
        // Prevent scrolling and other default actions.
        event.preventDefault();
        setMouse({
            x: event.targetTouches[0].clientX,
            y: event.targetTouches[0].clientY,
        });
        };

        const handleTouchEnd = () => {
        setMouse({ x: 0, y: 0 });
        };

        window.addEventListener('touchstart', handleTouchStart, { passive: false });
        window.addEventListener('touchmove', handleTouchMove, { passive: false });
        window.addEventListener('touchend', handleTouchEnd, { passive: false });

        // Cleanup listeners on component unmount
        return () => {
        window.removeEventListener('touchstart', handleTouchStart);
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
        };
    }, []);



    return (
        <>
            {/* <color attach="background" args={['#241a1a']} /> */}
            <Environment preset="park" />
            {/* <OrbitControls /> */}
            
            {/* <ScreenComponent setIsHovered={setIsHovered} /> */}
            <PresentationControls global rotation={[0.13, 0.1, 0]} polar={[-0.4, 0.2]} azimuth={[-1, 0.75]} config={{ mass: 3, tension: 300 }} snap={{ mass: 4, tension: 300 }}>
                <Float rotationIntensity={0.4}>
                    {/* <rectAreaLight width={2.5} height={1.65} intensity={70} color={'#ff6900'} rotation={[-0.1, Math.PI, 0]} position={[0, 0.55, -1.15]} /> */}
                    <animated.primitive
                        object={computer.scene}
                        position={[2, -1.0, -2.2]}
                        rotation={[0.13, -0.1, 0]}
                        scale={scale} // Apply the animated scale
                    >
                        <Html transform wrapperClass="htmlScreen" distanceFactor={1.17} position={[0, 1.56, -1.4]} rotation-x={-0.256}>
                            <iframe title="Project" src="https://projectsr3f.netlify.app/" />
                        </Html>
                    </animated.primitive>
                    <Text font="./bangers-v20-latin-regular.woff" fontSize={0.5} position={[2, 0.75, 0.75]} rotation-y={-1.25} maxWidth={2}>
                        MARQUIVION ORR
                    </Text>
                </Float>
            </PresentationControls>
            <ContactShadows position-y={-1.0} opacity={0.4} scale={5} blur={2.3} />
        </>
    );
}
